export const NOTIFICATION_TYPES = [
  "COMMENT_ENVIADO",
  "COMMENT_RESPONDIDO",
  "POSTULACION_SEND",
  "POSTULACION_ACCEPTED",
  "POSTULACION_NEGATED",
  "PRESUPUESTO_ENVIADO",
  "PRESUPUESTO_ACEPTADO",
  "PRESUPUESTO_NEGADO",
  "QUOTATION_SEND",
  "QUOTATION_MATERIALS_UPDATED",
  "USER_POSTULATION_SEND",
  "USER_FEATURED_POSTULATION_SEND",
  "USER_POSTULATION_ACCEPTED",
  "USER_POSTULATION_NEGATED",
  "NEW_PROFILE_VIEW",
  "NEW_PROFILE_REVIEW",
  "POST_LIKE_SEND",
  "POST_COMMENT_SEND",
  "POST_COMMENT_LIKE",
  "POST_COMMENT_RESPONSE",
  "NEW_CONTACT_REQUEST",
  "NEW_COINCIDENCES",
  "NEW_JOB_APLICATION",
  "NEW_QUESTION",
  "QUESTION_RESPONDIDO",
  "MATERIAL_DEMAND_ALERT",
  "MATERIAL_DEMAND_ALERT_GENERIC",
  "CATEGORY_CONNECT_ACTIVITY",
  "COMMENT_RECIBIDO",
  "QUOTATION_ACCEPTED",
  "QUOTATION_UPDATE",
  "USER_COMMENT_ENVIADO",
  "USER_COMMENT_RESPONDIDO",
  "USER_NEW_PROFILE_VIEW",
] as const;

export type NotificationTypeId = (typeof NOTIFICATION_TYPES)[number];

export type HubCategory =
  | "projects"
  | "materials"
  | "account"
  | "social"
  | "work"
  | "portfolio"
  | "system";

export type HubVisualVariant = "default" | "success" | "warning" | "info";

export type HubDetailVariant = "chip" | "text";

export type HubDetailLine = {
  text: string;
  variant: HubDetailVariant;
};

export const HUB_NOTIFICATION_TYPES_VISIBLE_ONLY_TO_ADMIN = new Set<string>([
  "USER_POSTULATION_SEND",
  "USER_FEATURED_POSTULATION_SEND",
  "USER_POSTULATION_ACCEPTED",
  "USER_POSTULATION_NEGATED",
]);
